import { render, staticRenderFns } from "./ReportTournamentPnl.vue?vue&type=template&id=605de34c"
import script from "./ReportTournamentPnl.vue?vue&type=script&lang=js"
export * from "./ReportTournamentPnl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports